import { render, staticRenderFns } from "./makeBidDocument.vue?vue&type=template&id=3c495d44&scoped=true"
import script from "./makeBidDocument.vue?vue&type=script&lang=js"
export * from "./makeBidDocument.vue?vue&type=script&lang=js"
import style0 from "./makeBidDocument.vue?vue&type=style&index=0&id=3c495d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c495d44",
  null
  
)

export default component.exports